import { referenceProjects } from "./projectImages";
import { additionalServiceProjects } from './serviceProjectImages';
import images from "./images";
import { serviceImages } from "./serviceImages";
import person2 from "../img/kavak-members/0002.jpg";
import khashayar from "../img/kavak-members/khashayar.jpg";
import babak from "../img/kavak-members/babak.jpg";
import amir from "../img/kavak-members/amir.jpg";
import yashar from "../img/kavak-members/yashar.jpg";
import mahdiyeh from "../img/kavak-members/mahdiyeh.jpg";
import kasra from "../img/kavak-members/kasra.jpg";
import asma from "../img/kavak-members/asma.jpg";
import mona from "../img/kavak-members/mona.jpg";
import morvarid from "../img/kavak-members/morvarid.jpg";
import negar from "../img/kavak-members/negar.jpg";
import negin from "../img/kavak-members/negin.jpg";
import kamyar from "../img/kavak-members/kamyar kiafar.jpg";
import sara from "../img/kavak-members/sara duzduzani.jpg";
import samira from "../img/kavak-members/samira.png";
import architectureIcon from "../img/icons/architecture.png";
import interiorDesignIcon from "../img/icons/interior design.png";
import healthIcon from "../img/icons/health.png";
import constructionIcon from "../img/icons/construction.png";
import reconstructionIcon from "../img/icons/reconstruction.png";

const legacyProjectsData = [
  {
    id: 1,
    title: "acasa interior design",

    projectName: "acasa",
    link: "/residential",
    desc: "A friendly atmosphere has been designed for a friend from abroad, in neo-classic style which is a combination of modern and classic styles. This design is a new experience of living in a warm and pleasant atmosphere besides their beloved family and friends and it is comfortable for splendid banquets and ceremonies and sharing these pleasant feelings with their family and friends.",
    specs: [
      { key: "PROJECT", value: "Acasa Interior Design" },
      { key: "LOCATION", value: "Tehran, Iran" },
      { key: "DATE", value: "2020" },
      { key: "AREA", value: "250 m²" },
    ],
  },
  {
    id: 2,
    title: "elahieh facade Design",

    projectName: "elahiye",
    link: "/residential",
    desc: "elahiyeh.desc",
    specs: [
      { key: "PROJECT", value: "Elahieh Facade Design" },
      { key: "LOCATION", value: " Iran, Tehran" },
      { key: "DATE", value: "2022" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 3,
    title: "khaneBala villa",

    projectName: "khaneBala",
    link: "/villa",
    desc: "Khanbala Villa provides the residents an opportunity to live in the heart of the nature. In this villa, architecture and nature are interwoven and the semi-open space captures identity. An opportunity for being in the open air and life-giving and natural elements are embedded in the life and the user is not only a spectator but also feel the surrounding nature. This attitude towards architecture is deeply rooted in northern nature of Iran and in the ancient houses in this region, semi-open spaces are the link between the nature and architecture. Our attitude towards the architecture of this region has been form-based and the main purpose of the architect was restoring the identity of the existing concepts.",
    specs: [
      { key: "PROJECT", value: "KhaneBala Villa" },
      { key: "LOCATION", value: "Iran, Mazandran, Nur" },
      { key: "DATE", value: "2022" },
      { key: "AREA", value: "500 m²" },
    ],
  },
  {
    id: 4,
    title: "khanjan villa",

    projectName: "khanjan",
    link: "/villa",
    desc: "Khanjan villa has been created out of limitations. The land of this villa has an area of 110 square meters. However, the architect prioritizes the feeling of authentic living. Regardless of the small scale of the project, this villa provides a desirable life for the inhabitants. The flow of life takes precedence over other issues. Two bedrooms have been designed in the ground floor and the kitchen and living room has been located in the floor at above, just next to the open space of the swimming pool and outdoor area.",
    specs: [
      { key: "PROJECT", value: "Khanjan Villa" },
      { key: "LOCATION", value: " Iran , Mazandaran" },
      { key: "DATE", value: "2020" },
      { key: "AREA", value: "110 m²" },
    ],
  },
  {
    id: 5,
    title: "korde villa",

    projectName: "kordeVilla",
    link: "/villa",
    desc: "This was a years-old building that has been used for storing goods which have been redesigned into an Iranian villa with a modern approach. The structure of the building and the vault arches are at our core attention and these arches as the main and constant element of Persian architecture become the basis of designing the new villa. With a sustainable attitude towards this building for optimal use of the combined atmosphere of the green wall located in the yard, a retire room has been created between swimming pool and other spaces. The residents have this opportunity to enjoy these spaces in all seasons and situations.",
    specs: [
      { key: "PROJECT", value: "Korde Villa" },
      { key: "LOCATION", value: "Tehran, Iran" },
      { key: "DATE", value: "2018" },
      { key: "AREA", value: "320 m²" },
    ],
  },
  {
    id: 6,
    title: "lutus residential",

    projectName: "lutus",
    link: "/residential",

    desc: "Lotus tower has been built in a land with eternal view; this building has variety  180 degree views. These different views for each unit provide a unique quality for each of them. Due to this fact that lutus project considers all city concerns, this uniqueness of the views attracts all lights from different sides. From the external point of view, this difference in design is clear for the outer observer as the combination of cubes facing different directions and creates the balance between the outer and inner observers.",
    specs: [
      { key: "PROJECT", value: "Lutus Residential Tower" },
      { key: "LOCATION", value: " Iran, Tehran" },
      { key: "DATE", value: "2020" },
      { key: "AREA", value: "6000 m²" },
    ],
  },
  {
    id: 7,
    title: "mehrdad interior design",

    projectName: "mehrdad",
    link: "/interior",
    desc: "Mehrdad project is a renovation project for redesigning the kitchen and small spaces between bedrooms. Renovation always faces more challenges in compare with Construction projects. However, kavak architecture group accepts restoration projections gladly. Because we believe that restoration is in consistent with helping our environment and reducing pollutions. In this project, the kitchen is connected to the living room. The entrance has improved and well defined. The space between the bedrooms is converted to library and work office.",
    specs: [
      { key: "PROJECT", value: "Mehrdad Interior Design" },
      { key: "LOCATION", value: "Iran, Tehran" },
      { key: "DATE", value: "2021" },
      { key: "AREA", value: "180 m²" },
    ],
  },
  {
    id: 8,
    title: "palazzo residential",

    projectName: "palazzo",
    link: "/residential",
    desc: "Plaza apartment project is located in Niyavaran, Tehran. The main idea of this project is the gap in the middle of the building that split it into two parts. This split allows us to create more private terraces .It also increases the link between the building and the surrounding environment because the elements of water and plant are the symbols of life in the heart of the building. The windows are tall and protruding in order to create a novel experience of sight and atmosphere. The outer wall, decorated with bar-like elements covered with green plants, adds to the transparency of the public space and results in more interaction between the building and the city.",
    specs: [
      { key: "PROJECT", value: "Palazzo Residential" },
      { key: "LOCATION", value: "Iran,Tehran" },
      { key: "DATE", value: "2021" },
      { key: "AREA", value: "3,200 m²" },
    ],
  },
  {
    id: 9,
    title: "paradise Residential",

    projectName: "paradise",
    link: "/residential",
    desc: "The main concern in designing this project is creating a living space on the side of the highway regardless of severe pollutions like voices and soot. Therefore, vertical filters, created from plant and water, have been embedded in front of the building which will subtilize the entering air. Public spaces have been considered beside these vertical filters for gatherings and children's entertainment which will create the unique experience of life in the building which could be an obstacle to exploring and reaching to perfection because of the urban features of the buildings. The remarkable point regarding this project is our attitude to the quantity and quality of the common and private spaces within the building.",
    specs: [
      { key: "PROJECT", value: "Paradise Residential" },
      { key: "LOCATION", value: "Iran, Tehran" },
      { key: "DATE", value: "2021" },
      { key: "AREA", value: "3000 m²" },
    ],
  },
  {
    id: 10,
    title: "refah commercial",

    projectName: "refah",
    link: "/commercial",
    desc: "Our main challenge in this project was to give power to the symbol of Refah mall which helps its original quality and glory, in such a way that its power can be felt in the overview of the project. Finally, the main part of the mall has been built like glassy storage so that the diversity of the products offered by the mall will be at the sight of the customers and will attract the them into entering the mall. The building of the mall was located in the city of Qazvin and the building structure has been built in advance and one of the concerns of the employer was for us to keep the existing structure.",
    specs: [
      { key: "PROJECT", value: "Refah Commercial Center" },
      { key: "LOCATION", value: " Iran, Qazvin" },
      { key: "DATE", value: "2020" },
      { key: "AREA", value: "9000 m²" },
    ],
  },
  {
    id: 21,
    title: "golestani shop",

    projectName: "golestani-shop",
    link: "/commercial",
    specs: [
      { key: "PROJECT", value: "Golestani Shop" },
      { key: "LOCATION", value: " Iran, Tehran" },
      { key: "DATE", value: "2014" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 22,
    title: "melli exchange",

    projectName: "melli-exchange",
    link: "/commercial",
    specs: [
      { key: "PROJECT", value: "Melli Exchange" },
      { key: "LOCATION", value: " Iran, Tehran" },
      { key: "DATE", value: "2010" },
      { key: "AREA", value: "750 m2" },
    ],
  },
  {
    id: 23,
    title: "nikan exchange",

    projectName: "nikan-exchange",
    link: "/commercial",
    specs: [
      { key: "PROJECT", value: "Nikan Exchange" },
      { key: "LOCATION", value: " Iran, Tehran" },
      { key: "DATE", value: "2024" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 23,
    title: "lavin",

    projectName: "lavin",
    link: "/industrial",
    specs: [
      { key: "PROJECT", value: "Lavin" },
      { key: "LOCATION", value: " Iran, Kurdistan" },
      { key: "DATE", value: "2023" },
      { key: "AREA", value: "15 Ha" },
    ],
  },
  {
    id: 24,
    title: "pharmed plast",

    projectName: "pharmed-plast",
    link: "/industrial",
    desc: "pharmed_plast.desc",
    specs: [
      { key: "PROJECT", value: "Pharmed Plast" },
      { key: "LOCATION", value: "" },
      { key: "DATE", value: "" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 25,
    title: "nova pharmed",

    projectName: "nova-pharmed",
    link: "/industrial",
    desc: "nova_pharmed.desc",
    specs: [
      { key: "PROJECT", value: "Nova Pharmed" },
      { key: "LOCATION", value: "" },
      { key: "DATE", value: "" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 26,
    title: "OBP",

    projectName: "OBP",
    link: "/interior",
    specs: [
      { key: "PROJECT", value: "OBP" },
      { key: "LOCATION", value: "Omman, Muscat" },
      { key: "DATE", value: "2024" },
      { key: "AREA", value: "300 m2" },
    ],
  },
  {
    id: 27,
    title: "sarv",

    projectName: "sarv",
    link: "/interior",
    specs: [
      { key: "PROJECT", value: "sarv" },
      { key: "LOCATION", value: " Iran, Shemshak" },
      { key: "DATE", value: "2024" },
      { key: "AREA", value: "188 m2" },
    ],
  },
  {
    id: 28,
    title: "shahpasand",

    projectName: "shahpasand",
    link: "/interior",
    specs: [
      { key: "PROJECT", value: "shahpasand" },
      { key: "LOCATION", value: "Iran, Tehran" },
      { key: "DATE", value: "2025" },
      { key: "AREA", value: "170 m2" },
    ],
  },
  {
    id: 29,
    title: "sartomax",

    projectName: "sartomax",
    link: "/interior",
    specs: [
      { key: "PROJECT", value: "sartomax" },
      { key: "LOCATION", value: "United Emirates, Dubai" },
      { key: "DATE", value: "2024" },
      { key: "AREA", value: "170 m2" },
    ],
  },
  {
    id: 30,
    title: "ODCC",

    projectName: "ODCC",
    link: "/interior",
    specs: [
      { key: "PROJECT", value: "ODCC" },
      { key: "LOCATION", value: "Iran, Tehran" },
      { key: "DATE", value: "" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 31,
    title: "makooeipoor",

    projectName: "makooeipoor",
    link: "/interior",
    specs: [
      { key: "PROJECT", value: "makooeipoor" },
      { key: "LOCATION", value: "Iran, Tehran" },
      { key: "DATE", value: "" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 32,
    title: "hafez",

    projectName: "hafez",
    link: "/office",
    specs: [
      { key: "PROJECT", value: "hafez" },
      { key: "LOCATION", value: " Iran, Tehran" },
      { key: "DATE", value: "2023" },
      { key: "AREA", value: "7200 m2" },
    ],
  },
  {
    id: 33,
    title: "fereshteh",

    projectName: "fereshteh",
    link: "/office",
    desc: "fereshteh.desc",
    specs: [
      { key: "PROJECT", value: "fereshteh" },
      { key: "LOCATION", value: "Iran, Tehran" },
      { key: "DATE", value: "2025" },
      { key: "AREA", value: "400 m2" },
    ],
  },
  {
    id: 34,
    title: "holding gandi",

    projectName: "holding-gandi",
    link: "/office",
    specs: [
      { key: "PROJECT", value: "holding-gandi" },
      { key: "LOCATION", value: " Iran, Tehran" },
      { key: "DATE", value: "2023" },
      { key: "AREA", value: "5000 m2" },
    ],
  },
  {
    id: 35,
    title: "ansaldo",

    projectName: "ansaldo",
    link: "/office",
    specs: [
      { key: "PROJECT", value: "ansaldo" },
      { key: "LOCATION", value: " Iran, Damavand" },
      { key: "DATE", value: "2025" },
      { key: "AREA", value: "300 m2" },
    ],
  },
  {
    id: 36,
    title: "modular house",

    projectName: "modular-house",
    link: "/residential",
    specs: [
      { key: "PROJECT", value: "modular-house" },
      { key: "LOCATION", value: "EveryWhere" },
      { key: "DATE", value: "2022" },
      { key: "AREA", value: "20-300 m2" },
    ],
  },
  {
    id: 36,
    title: "mehr o mah",

    projectName: "mehr-o-mah",
    link: "/restaurant",
    specs: [
      { key: "PROJECT", value: "mehr-o-mah" },
      { key: "LOCATION", value: "Iran Qom" },
      { key: "DATE", value: "" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 37,
    title: "mahtab",

    projectName: "mahtab",
    link: "/restaurant",
    specs: [
      { key: "PROJECT", value: "mahtab" },
      { key: "LOCATION", value: "Iran Qom" },
      { key: "DATE", value: "" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 38,
    title: "cafe bakery dubai",

    projectName: "cafe-bakery-dubai",
    link: "/restaurant",
    specs: [
      { key: "PROJECT", value: "cafe-bakery-dubai" },
      { key: "LOCATION", value: "" },
      { key: "DATE", value: "" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 39,
    title: "arta",

    projectName: "arta",
    link: "/villa",
    desc: "arta.desc",
    specs: [
      { key: "PROJECT", value: "arta" },
      { key: "LOCATION", value: "Iran, Mazandran, Izadshahr" },
      { key: "DATE", value: "2025-2026" },
      { key: "AREA", value: "1000 m2" },
    ],
  },
  {
    id: 40,
    title: "ana",

    projectName: "ana",
    link: "/villa",
    desc: "ana.desc",
    specs: [
      { key: "PROJECT", value: "ana" },
      { key: "LOCATION", value: "Iran, Mazandran, Izadshahr" },
      { key: "DATE", value: "2025-2026" },
      { key: "AREA", value: "500 m2" },
    ],
  },
  {
    id: 41,
    title: "baghe gherdoo",

    projectName: "baghe-gerdoo",
    link: "/villa",
    specs: [
      { key: "PROJECT", value: "baghe-gerdoo" },
      { key: "LOCATION", value: "Iran, Qazvin, Haft Sangan" },
      { key: "DATE", value: "2010" },
      { key: "AREA", value: "2200 m2" },
    ],
  },
  {
    id: 42,
    title: "azadeh",

    projectName: "azadeh",
    link: "/villa",
    desc: "azadeh.desc",
    specs: [
      { key: "PROJECT", value: "azadeh" },
      { key: "LOCATION", value: "Iran, KhezerShahr" },
      { key: "DATE", value: "2024" },
      { key: "AREA", value: "500 m2" },
    ],
  },
  {
    id: 43,
    title: "TYULIFE",

    projectName: "TYULIFE",
    link: "/healthcare",
    specs: [
      { key: "PROJECT", value: "TYULIFE" },
      { key: "LOCATION", value: "United Emirates, Dubai" },
      { key: "DATE", value: "2022" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 44,
    title: "mom",

    projectName: "mom",
    link: "/healthcare",
    specs: [
      { key: "PROJECT", value: "mom" },
      { key: "LOCATION", value: "Omman, Muscat" },
      { key: "DATE", value: "2023" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 45,
    title: "yon therapy",

    projectName: "yon-therapy",
    link: "/healthcare",
    desc: "Our main challenge in this project was to give power to the symbol of Refah mall which helps its original quality and glory, in such a way that its power can be felt in the overview of the project. Finally, the main part of the mall has been built like glassy storage so that the diversity of the products offered by the mall will be at the sight of the customers and will attract the them into entering the mall. The building of the mall was located in the city of Qazvin and the building structure has been built in advance and one of the concerns of the employer was for us to keep the existing structure.",
    specs: [
      { key: "PROJECT", value: "yon-therapy" },
      { key: "LOCATION", value: "Iran, Tehran" },
      { key: "DATE", value: "" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 46,
    title: "b brun",

    projectName: "b-brun",
    link: "/healthcare",
    desc: "b-brun.desc",
    specs: [
      { key: "PROJECT", value: "b-brun" },
      { key: "LOCATION", value: "Iran, Tehran" },
      { key: "DATE", value: "" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 47,
    title: "chamran",

    projectName: "chamran",
    link: "/healthcare",
    desc: "chamran.desc",
    specs: [
      { key: "PROJECT", value: "chamran" },
      { key: "LOCATION", value: "Iran, Tehran" },
      { key: "DATE", value: "" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 48,
    title: "olgoo",

    projectName: "olgoo",
    link: "/highrize",
    // desc: "olgoo.desc",
    specs: [
      { key: "PROJECT", value: "olgoo" },
      { key: "LOCATION", value: "Iran, Tehran" },
      { key: "DATE", value: "" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 49,
    title: "TYULIFE",

    projectName: "TYULIFE",
    link: "/international",
    specs: [
      { key: "PROJECT", value: "TYULIFE" },
      { key: "LOCATION", value: "United Emirates, Dubai" },
      { key: "DATE", value: "2022" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 50,
    title: "sartomax",

    projectName: "sartomax",
    link: "/international",
    specs: [
      { key: "PROJECT", value: "sartomax" },
      { key: "LOCATION", value: "United Emirates, Dubai" },
      { key: "DATE", value: "2024" },
      { key: "AREA", value: "170 m2" },
    ],
  },
  {
    id: 51,
    title: "cafe bakery dubai",

    projectName: "cafe-bakery-dubai",
    link: "/international",
    specs: [
      { key: "PROJECT", value: "cafe-bakery-dubai" },
      { key: "LOCATION", value: "United Emirates, Dubai" },
      { key: "DATE", value: "" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 52,
    title: "OBP",

    projectName: "OBP",
    link: "/international",
    specs: [
      { key: "PROJECT", value: "OBP" },
      { key: "LOCATION", value: "Omman, Muscat" },
      { key: "DATE", value: "2024" },
      { key: "AREA", value: "300 m2" },
    ],
  },
  {
    id: 53,
    title: "mom",

    projectName: "mom",
    link: "/international",
    specs: [
      { key: "PROJECT", value: "mom" },
      { key: "LOCATION", value: "Omman, Muscat" },
      { key: "DATE", value: "2023" },
      { key: "AREA", value: "" },
    ],
  },
  {
    id: 11,
    title: "roshd sport Complex",

    projectName: "roshd",
    link: "/sport",
    desc: "Roshd sports complex has been built in Chizar neighborhood for reinforcing the process of life, well-being, and health. Considering the advent of new sports and their combination with older sports, our main concern in designing the complex was creating different spaces for different people who can enjoy their time during their presence in the complex. Therefore, different spaces for aerobic exercises, hydrotherapy, and etc. have been designed. Because this complex consists of different spaces, we decided to create a similar feeling for all of the people at the entrance of the complex and increase their heart beat and make them ready for their exercise. We do this by creating optical lines inside the walls of the entrance part.",
    specs: [
      { key: "PROJECT", value: "Roshd Sport Complex" },
      { key: "LOCATION", value: "Iran, Tehran" },
      { key: "DATE", value: "2022" },
      { key: "AREA", value: "10000 m²" },
    ],
  },
  {
    id: 12,
    title: "tav office",

    projectName: "tav",
    link: "/office",

    desc: "Our main discussion regarding this project was YLG Company's transparency of performance towards its customers and clients. This transparency has been brought into the internal atmosphere of their projects; therefore, atmospheres that have been designed, not only created a private environment but also provided a good perspective for interacting with the customers. This triggers exploring the feeling of social living within the work environment which have presented itself in these transparencies: the green line that has been designed in the surrounded area that reaches to the zenith in the waiting hall.",
    specs: [
      { key: "PROJECT", value: "TAV Office" },
      { key: "LOCATION", value: "Iran, Tehran" },
      { key: "DATE", value: "2022" },
      { key: "AREA", value: "150 m²" },
    ],
  },
  {
    id: 13,
    title: "tagharon residential",

    projectName: "tagharon",
    link: "/residential",
    desc:
      "This project's site was a narrow and extending one with a width of 10m and a length of 60m. \n" +
      "The owner wanted the top floors to be studio flats and for the grand floor to be retail.\n" +
      "All the studio spaces possess the same value also they are similar to each other and they are modular in their own way; so we drove the modularity into the facade.\n" +
      "Arches have always been an essential element for architecture in the south of Iran since they are the right choice according to the climate and aesthetic.\n" +
      "Having the arch modules alongside the windows installed back and forth causes shading on the facade and prevents direct sunlight to meet the windows \n" +
      'We tried to use aboriginal materials such as "clay straw".\n' +
      "This material won't absorb the sun's radiation and that will help with interior temperature control as well.\n" +
      "The color of this material works out just fine since it reflects the light in a way that won't harm the eyes as the white color will do on this region.\n" +
      "The grand floor is designed to be retail stores and 3 other elevations are placed above that.\n" +
      "each studio flat in the elevations has about 40m2 of area.\n" +
      "on the rooftop, the arches create green semi-open spaces for people to pass or stay in.",
    specs: [
      { key: "PROJECT", value: "Tagharon Residential" },
      { key: "LOCATION", value: "Qeshm Island, Iran" },
      { key: "DATE", value: "2023" },
      { key: "AREA", value: "600 m²" },
    ],
  },
  {
    id: 14,
    title: "alamoot villa",

    projectName: "alamoot",
    link: "/villa",
    desc: "alamoot.desc",
    specs: [
      { key: "PROJECT", value: "Alamoot Villa" },
      { key: "LOCATION", value: "Alamoot, Qazvin, Iran" },
      { key: "DATE", value: "2022" },
      { key: "AREA", value: "450 m²" },
    ],
  },
  {
    id: 15,
    title: "nasiri interior design",

    projectName: "nasiri",
    link: "/interior",
    specs: [
      { key: "PROJECT", value: "Nasiri Interior Design" },
      { key: "LOCATION", value: "Tehran, Iran" },
      { key: "DATE", value: "2021" },
      { key: "AREA", value: "200 m²" },
    ],
  },
  {
    id: 16,
    title: "kajabadi office",

    projectName: "kajabadi",
    link: "/office",

    specs: [
      { key: "PROJECT", value: "Kajabadi Office" },
      { key: "LOCATION", value: "Tehran, Iran" },
      { key: "DATE", value: "2023" },
      { key: "AREA", value: "480 m²" },
    ],
  },
  {
    id: 17,
    title: "medway industrial",

    projectName: "medway",
    link: "/industrial",
    desc: "medway.desc",
    specs: [
      { key: "PROJECT", value: "Medway Industrial" },
      { key: "LOCATION", value: "Iran, Eshtehard" },
      { key: "DATE", value: "2022" },
      { key: "AREA", value: "12,000 m²" },
    ],
  },
  {
    id: 18,
    title: "under sea restaurant",

    projectName: "undersea",
    link: "/restaurant",

    desc:
      "The project was meant to be a well-received restaurant close to the Persian Gulf shore\n" +
      "the main concept was to preserve Kish island's ambiance within the structure's spirit.\n" +
      " We wanted to develop a soft, sponge-like shape and through its disposition, form a shell with coral reef character.\n" +
      "The roof has been made from a variety of melted-sphere-shape light masses that had been connected to each other by local mats. The mat arches connect the edges of the roof while it connects the restaurant with the native culture of the area.\n" +
      "\n" +
      " From the outside, the shell looks like a double flat building but actually, the first floor itself contains two levels.\n" +
      " The top floor is a semi-open space that has an excellent view of the sea. It feels like sitting outside for the ones who are sitting in the roof since the woven roof has been installed higher than the walls and the fresh air running inside constantly.\n" +
      " Our mission was to bring the life and action flowing under the sea, into our interior space's atmosphere.\n" +
      "\n" +
      " For the top floor, we decided for water to be our parapet and that works out fine since we wanted the see ecosystem to be brought up into the restaurant's space.\n" +
      "We picked traditional local light fixtures and mat arches since they could be provided by local producers and they were elements of the town in which the restaurant is located.",
    specs: [
      { key: "PROJECT", value: "Under Sea Restaurant" },
      { key: "LOCATION", value: "Iran, Kish Island" },
      { key: "DATE", value: "2022" },
      { key: "AREA", value: "1450 m²" },
    ],
  },
  {
    id: 19,
    title: "apartment No.12",

    projectName: "No12",
    link: "/residential",

    desc:
      "No.12 apartment is a renovation project. this building has been built in 2006 by a family and it turned out to be a family apartment; with the children marrying and starting living there as well ever since.\n" +
      "The main challenge in this building was to design a new lobby without the building having one already.\n" +
      "There was an opportunity to expand the footprint since the building next to ours, had changed its plan.\n" +
      "Although changing the plans gave us more area, it wasn't enough to create a lobby so we decided to relocate the ground floor's stairs in order to have more space for the lobby. We used that extra footprint on the ground floor as extensions to the existing balconies on the floors above.\n" +
      "Renovating the façade and defining the yard to be welcoming, were the second priorities of the project.\n" +
      "The extended balconies are serving the facade for creating high hollow boxes, in which we maintain to implant 2 Iranian cypress trees.\n" +
      "In order to have natural light in the stair box, we decided for the extended volume to be semi-open and its shell to be transparent with a pattern. We also expanded the pattern to be on the other parts of the façade.\n" +
      "The concept of redesigning the existing façade is connected to Kavak's identity (to admire empty space)\n" +
      "we centralize the empty spaces in between the projected volumes\n" +
      "by adding some v-shaped-walls from the ground floor to the top floor on the façade, we made some vertical empty spaces to change it plaid pattern to the new identity.",
    specs: [
      { key: "PROJECT", value: "Apartment No.12" },
      { key: "LOCATION", value: "Tehran, Iran" },
      { key: "DATE", value: "2023" },
      { key: "AREA", value: "1,500 m²" },
    ],
  },
  {
    id: 20,
    title: "digital hospital",

    projectName: "digiHospital",
    link: "/healthcare",


    desc: "In today's modern world digital industry has been involved in our daily lives. Imagine a world in which most hospitals are on the verge of digitalization. Imagine that your medical information will be investigated not only by national physicians but also by inner national medical experts. In this concept all of the medical procedures including visits and checkups medical examinations, laboratory services, and consultation with high-procedure medical experts will be provided in an interrogated global eco-systems also in one intergraded application your whole medical data will be recorded in a centralized system. Imagine while approaching the hospital your appointment is already scheduled and all of the required set up including the medical team and necessary equipment are available based on your medical mates, even a particular navigator will lead you to your exclusive room in the hospital. You will spend your treatment procedure comfortably in the hospital room since all of the official and medical processes would be conducted for the yc4y app least time-consuming actions and comfort are the major purposes of this system. Rather than experiencing risky conditions and constable expenses at the hospital Your able to bring the hospital room including professional equipment to your own home. Moreover, you will be under the supervision experience nurses and your treatment procedures will be constantly investigated by the medical team via the online database. All of your medical data will be recorded in your personal documentation and in this case, it is required it will be easily accessible for you and your doctor.",
    specs: [
      { key: "PROJECT", value: "Digital Hospital" },
      { key: "LOCATION", value: "Tehran, Iran" },
      { key: "DATE", value: "2024" },
      { key: "AREA", value: "15,000 m²" },
    ],
  },
];

export const serviceCard = [
  {
    icon: (
      <img
        className="iconImage"
        alt="interior-design"
        src={interiorDesignIcon}
      />
    ),
    title: "DESIGN",
    titleKey: "services.design.title",
    descriptionKey: "services.interior-design.description",
    description:
      "We design your interior spaces so that it meets all your needs and we let the spirit of your life flow through them.",
    href: "/services/design",
    slug: "design",
    src: serviceImages.design,
  },
  {
    slug: "healthcare",
    titleKey: "services.healthcare.title",
    title: "Healthcare",
    descriptionKey: "services.healthcare.cartDescription",
    description:
      "Specialized healthcare facility design and planning services.",
    icon: <img className="iconImage" src={healthIcon} alt="healthcare" />,
    href: "/services/healthcare",
    src: serviceImages.healthcare,
  },
  {
    icon: (
      <img className="iconImage" alt="construction" src={constructionIcon} />
    ),
    title: "CONSTRUCTION",
    titleKey: "services.CONSTRUCTION.title",
    descriptionKey: "services.construction.description",
    description:
      "We overcome the gap between the designer and the implementation team by having a construction team of our own.",
    href: "/services/construction",
    slug: "construction",
    src: serviceImages.construction,
  },
  {
    icon: <img className="iconImage" alt="DRYWALL" src={architectureIcon} />,
    title: "DRYWALL",
    titleKey: "services.drywall.title",
    descriptionKey: "services.DRYWALL.description",
    description:
      "We always try to design creatively as well as finding the best solutions for architectural problems.",
    href: "/services/drywall",
    slug: "drywall",
    src: serviceImages.drywall,
  },
  {
    icon: (
      <img className="iconImage" alt="consulting" src={reconstructionIcon} />
    ),
    title: "CONSULTING",
    titleKey: "services.consulting.title",
    descriptionKey: "services.consulting.description",
    description:
      "Our consulting services help you make informed decisions from concept to completion.",
    href: "/services/consulting",
    slug: "consulting",
    src: serviceImages.consulting,
  },
  {
    icon: (
      <img className="iconImage" alt="supervision" src={reconstructionIcon} />
    ),
    title: "BIM",
    titleKey: "services.bim.title",
    descriptionKey: "services.BIM.description",
    description:
      "We provide expert supervision throughout the entire project lifecycle to ensure quality and compliance.",
    href: "/services/bim",
    slug: "bim",
    src: serviceImages.bim,
  },
];
export const projectsImage = [
  {
    tittle: "ACASSA",
    image: images.acasa,
  },
  { tittle: "TAV OFFICE", image: images.tavOffice },
  { tittle: "KHANE BALA VILLA", image: images.khanaBalaVilla },
];

export const ourTeamImages = [
  { id: 1, image: khashayar, personName: "Khashayar Khamesi", job: "C.E.O" },
  { id: 2, image: asma, personName: "Asma Bagheri", job: "Design Manager" },
  {
    id: 3,
    image: samira,
    personName: "Samira Ramezani",
    job: "Healthcare Design Manager",
  },
  {
    id: 4,
    image: babak,
    personName: "Babak Khajeh",
    job: "Construction Manager",
  },
  {
    id: 5,
    image: yashar,
    personName: "Yashar Shahmansouri",
    job: "Drywall Construction Manager",
  },

  { id: 6, image: kasra, personName: "Kasra Asgharpour", job: "Board Member" },
  { id: 7, image: kamyar, personName: "Kamyar Kiafar", job: "Board Member" },

  { id: 8, image: sara, personName: "Sara Duzduzani", job: "Designer" },
  { id: 9, image: negar, personName: "Negar Asgharinejad", job: "3D Artist" },
  { id: 10, image: negin, personName: "Negin Takhtayinia", job: "Designer" },
  { id: 11, image: morvarid, personName: "Morvarid Rahimi", job: "Designer" },
  {
    id: 12,
    image: mahdiyeh,
    personName: "Mahdieh Azizi",
    job: "Financial Manager",
  },
];
// ============ Service Detail Data ============
export const serviceDetailData = {
  consulting: {
    slug: "consulting",
    titleKey: "services.consulting.title",
    title: "CONSULTING",
    heroImage: serviceImages.consulting,
    // descriptionKey: "service.desc.consulting",
    // sections: [
    //   {
    //     titleKey: "services.architecture.detail.section1.title",
    //     title: "Our Approach",
    //     contentKey: "services.architecture.detail.section1.content",
    //     content:
    //       "We begin every project by listening carefully to our clients, understanding their vision, and studying the site conditions. Our design process is iterative and collaborative — we explore multiple concepts before refining the one that best responds to the project's unique requirements. From residential villas to large-scale commercial complexes, we approach each project with the same dedication to excellence.",
    //   },
    //   {
    //     titleKey: "services.architecture.detail.section2.title",
    //     title: "What We Offer",
    //     contentKey: "services.architecture.detail.section2.content",
    //     content:
    //       "• Conceptual Design & Feasibility Studies\n• Schematic Design & Design Development\n• Construction Documentation\n• 3D Visualization & Physical Models\n• Sustainable & Green Design Solutions\n• Urban Planning & Master Planning",
    //   },
    //   {
    //     titleKey: "services.architecture.detail.section3.title",
    //     title: "Why Choose Us",
    //     contentKey: "services.architecture.detail.section3.content",
    //     content:
    //       "With over a decade of experience, our architecture team has successfully delivered projects across residential, commercial, cultural, and hospitality sectors. We believe that great architecture comes from the balance of art and science — and that is exactly what we strive to achieve in every project.",
    //   },
    // ],
    stats: [
      {
        label: "Projects Completed",
        labelKey: "services.stats.projectsCompleted",
        value: "120+",
      },
      {
        label: "Years Experience",
        labelKey: "services.stats.yearsExperience",
        value: "12+",
      },
      { label: "Awards Won", labelKey: "services.stats.awardsWon", value: "8" },
    ],
  },

  design: {
    slug: "design",
    titleKey: "services.design.title",
    title: "DESIGN",
    heroImage: serviceImages.design,
    descriptionKey: "service.design.desc",
    description:
      "Interior design at Kavak is about crafting environments that reflect the personality of the people who inhabit them. We believe that every space tells a story, and our job is to make that story beautiful, functional, and uniquely yours.",
    // sections: [
    //   {
    //     titleKey: "services.interior-design.detail.section1.title",
    //     title: "Our Philosophy",
    //     contentKey: "services.interior-design.detail.section1.content",
    //     content:
    //       "We approach interior design as a holistic discipline — considering not just aesthetics, but also how light, materials, textures, and spatial proportions work together to create an atmosphere. Our designs are tailored to each client, blending timeless elegance with contemporary functionality.",
    //   },
    //   {
    //     titleKey: "services.interior-design.detail.section2.title",
    //     title: "Services Include",
    //     contentKey: "services.interior-design.detail.section2.content",
    //     content:
    //       "• Space Planning & Layout Design\n• Material & Finish Selection\n• Custom Furniture Design\n• Lighting Design\n• Color Consultation\n• Art & Accessory Curation\n• Kitchen & Bathroom Design",
    //   },
    //   {
    //     titleKey: "services.interior-design.detail.section3.title",
    //     title: "Our Process",
    //     contentKey: "services.interior-design.detail.section3.content",
    //     content:
    //       "From the initial consultation to the final styling, we guide our clients through every step. We create detailed mood boards, 3D renderings, and material samples before any construction begins — ensuring that the final result matches your vision perfectly.",
    //   },
    // ],
    stats: [
      {
        label: "Spaces Designed",
        labelKey: "services.stats.spacesDesigned",
        value: "200+",
      },
      {
        label: "Happy Clients",
        labelKey: "services.stats.happyClients",
        value: "150+",
      },
      {
        label: "Custom Pieces",
        labelKey: "services.stats.customPieces",
        value: "500+",
      },
    ],
  },

  construction: {
    slug: "construction",
    titleKey: "services.CONSTRUCTION.title",
    title: "CONSTRUCTION",
    heroImage: serviceImages.construction,
    descriptionKey: "service.CONSTRUCTION.desc",
    // sections: [
    //   {
    //     titleKey: "services.construction.detail.section1.title",
    //     title: "Integrated Design-Build",
    //     contentKey: "services.construction.detail.section1.content",
    //     content:
    //       "Unlike traditional approaches where design and construction are separate, our integrated model means the same team that designs your project also builds it. This eliminates miscommunication, reduces costs, and accelerates timelines.",
    //   },
    //   {
    //     titleKey: "services.construction.detail.section2.title",
    //     title: "Our Capabilities",
    //     contentKey: "services.construction.detail.section2.content",
    //     content:
    //       "• Residential Construction (Villas, Apartments, Townhouses)\n• Commercial Construction (Offices, Retail, Mixed-Use)\n• Structural Engineering Coordination\n• MEP Systems Installation\n• Quality Control & Testing\n• Project Scheduling & Budget Management",
    //   },
    //   {
    //     titleKey: "services.construction.detail.section3.title",
    //     title: "Quality Assurance",
    //     contentKey: "services.construction.detail.section3.content",
    //     content:
    //       "Every project undergoes rigorous quality checks at each phase. We use premium materials, employ skilled craftsmen, and follow international construction standards to deliver buildings that stand the test of time.",
    //   },
    // ],
    stats: [
      {
        label: "Sqm Built",
        labelKey: "services.stats.sqmBuilt",
        value: "50,000+",
      },
      {
        label: "Active Sites",
        labelKey: "services.stats.activeSites",
        value: "5",
      },
      {
        label: "Team Members",
        labelKey: "services.stats.teamMembers",
        value: "40+",
      },
    ],
  },

  drywall: {
    slug: "drywall",
    titleKey: "services.drywall.title",
    title: "DRYWALL",
    heroImage: serviceImages.drywall,
    descriptionKey: "service.Drywall.desc",
    description:
      "We believe in giving buildings a second life. Renovation is not just about fixing what is broken — it is about reimagining spaces to meet contemporary needs while preserving their original character and reducing environmental impact.",
    // sections: [
    //   {
    //     titleKey: "services.renovation.detail.section1.title",
    //     title: "Sustainable Thinking",
    //     contentKey: "services.renovation.detail.section1.content",
    //     content:
    //       "Demolishing and rebuilding generates enormous waste and carbon emissions. By choosing renovation, you save up to 50-75% of the embodied energy in existing structures. Our approach maximizes reuse while transforming spaces into something extraordinary.",
    //   },
    //   {
    //     titleKey: "services.renovation.detail.section2.title",
    //     title: "Renovation Services",
    //     contentKey: "services.renovation.detail.section2.content",
    //     content:
    //       "• Complete Interior Renovation\n• Facade Restoration & Modernization\n• Structural Reinforcement\n• Space Reconfiguration\n• Energy Efficiency Upgrades\n• Heritage Building Restoration\n• Adaptive Reuse Projects",
    //   },
    //   {
    //     titleKey: "services.renovation.detail.section3.title",
    //     title: "Before & After",
    //     contentKey: "services.renovation.detail.section3.content",
    //     content:
    //       "Our portfolio showcases dramatic transformations — from outdated commercial spaces turned into modern offices, to historic homes restored to their former glory with contemporary amenities seamlessly integrated.",
    //   },
    // ],
    stats: [
      {
        label: "Renovations Done",
        labelKey: "services.stats.renovationsDone",
        value: "80+",
      },
      {
        label: "Cost Saved",
        labelKey: "services.stats.costSaved",
        value: "35%",
      },
      {
        label: "Client Satisfaction",
        labelKey: "services.stats.clientSatisfaction",
        value: "98%",
      },
    ],
  },

  bim: {
    slug: "bim",
    titleKey: "services.bim.title",
    title: "BIM",
    heroImage: serviceImages.bim,
    descriptionKey: "services.bim.detail.description",
    description:
      "Building Information Modeling (BIM) is a transformative approach to construction that enhances collaboration, improves efficiency, and reduces costs. Our BIM services leverage cutting-edge technology to create detailed 3D models, enabling better decision-making throughout the project lifecycle.",
    // sections: [
    //   {
    //     titleKey: "services.bim.detail.section1.title",
    //     title: "On-Site Excellence",
    //     contentKey: "services.bim.detail.section1.content",
    //     content:
    //       "Our experienced supervisors are present on-site daily, monitoring progress, inspecting workmanship, and coordinating between contractors. We catch issues before they become problems, saving you time and money.",
    //   },
    //   {
    //     titleKey: "services.bim.detail.section2.title",
    //     title: "BIM Scope",
    //     contentKey: "services.bim.detail.section2.content",
    //     content:
    //       "• 3D Modeling & Visualization\n• Clash Detection & Resolution\n• Construction Sequencing\n• Cost Estimation & Budgeting\n• Facility Management Integration\n• Collaboration & Communication Tools\n• Data Management & Analysis",
    //   },
    //   {
    //     titleKey: "services.bim.detail.section3.title",
    //     title: "Transparent Reporting",
    //     contentKey: "services.bim.detail.section3.content",
    //     content:
    //       "Clients receive regular reports with photos, progress updates, and any issues identified. Our digital reporting system keeps you informed in real-time, even if you are not on site.",
    //   },
    // ],
    stats: [
      {
        label: "Projects Supervised",
        labelKey: "services.stats.projectsSupervised",
        value: "60+",
      },
      {
        label: "Issues Prevented",
        labelKey: "services.stats.issuesPrevented",
        value: "300+",
      },
      {
        label: "On-Time Delivery",
        labelKey: "services.stats.onTimeDelivery",
        value: "95%",
      },
    ],
  },
  healthcare: {
    slug: "healthcare",
    titleKey: "services.healthcare.title",
    title: "HEALTHCARE",
    heroImage: serviceImages.healthcare,
    descriptionKey: "services.health.description",
    description:
      "The healthcare sector is among the most specialized and sensitive fields, and its successful implementation requires deep knowledge, practical experience, and precise operational structures. With a specialized focus on healthcare projects, we provide comprehensive and integrated solutions covering everything from planning to execution and operation.",
    // توضیح بلند دوم (پاراگراف‌های اضافی مقدمه)
    introExtendedKey: "services.health.introExtended",
    introExtended:
      "The Healthcare Facility Design Department at Kavak specializes in the design and planning of healthcare and medical spaces. The core design team of this department consists of professionals, each with at least 15 years of experience in functional medical architecture, development of healthcare design standards for the Ministry of Health (Safe Hospital Design Standards), collaboration with prominent healthcare architects in Iran, and participation in the design and execution of major domestic healthcare projects.\n\nFurthermore, the experience of designing healthcare facility architecture in an integrated manner, directly linked to medical equipment — which itself accounts for a significant share of healthcare services — is one of the distinctive advantages of this team. Medical equipment, due to its direct relationship with diagnostic and treatment scenarios, specialized workflows, and specific installation requirements, is always considered one of the main pillars in healthcare space design.\n\nPrecise and timely planning in this field, from the very beginning of the architectural design process — based on our team's specialized knowledge — not only optimizes the performance of healthcare facilities but also prevents future damages and operational problems that result from overlooking this issue.\n\nIn the field of interior architecture, creating healing spaces based on a thorough understanding of needs, standards, functions, and limitations of healthcare environments — where architecture is recognized as one of the effective pillars in the healthcare process — is the main approach of this team, pursued with specialized expertise in architecture and anthropology.",
    // اطلاعات ۲ نفر (عکس + اسم + سمت)
    teamMembers: [
      {
        nameKey: "services.health.team.member1.name",
        name: "Member Name 1",
        roleKey: "services.health.team.member1.role",
        role: "Healthcare Architecture Lead",
        image: null, // بعداً عکس واقعی
        resumeLink: null, // بعداً لینک رزومه
      },
      {
        nameKey: "services.health.team.member2.name",
        name: "Member Name 2",
        roleKey: "services.health.team.member2.role",
        role: "Medical Consultant",
        image: null,
        resumeLink: null,
      },
    ],
    // ۷ سرویس زیرمجموعه — اینها section هستن ولی لینک‌دار
    sections: [
      {
        titleKey: "services.health.section1.title",
        title: "Healthcare Architecture and Facility Planning",
        titleFa: "معماری تخصصی فضاهای درمانی",
        contentKey: "services.health.section1.content",
        content:
          "Comprehensive specialized services in planning and architecture of healthcare and medical spaces. Healthcare space design based on the project master plan.",
        slug: "healthcare-architecture-and-facility-planning",
        isLink: true,
      },
      {
        titleKey: "services.health.section2.title",
        title: "Healthcare Service Planning",
        titleFa: "طرح‌ریزی و مدیریت خدمات بهداشتی-درمانی",
        contentKey: "services.health.section2.content",
        content:
          "Strategic planning and management of healthcare services to ensure optimal patient care delivery and operational efficiency.",
        slug: "healthcare-service-planning",
        isLink: true,
      },
      {
        titleKey: "services.health.section3.title",
        title: "Medical Equipment Planning and Biomedical Engineering Service",
        titleFa: "طراحی تجهیز در مراکز درمانی و ارائه خدمات مهندسی پزشکی",
        contentKey: "services.health.section3.content",
        content:
          "Expert medical equipment planning integrated with biomedical engineering services for healthcare facilities.",
        slug: "medical-equipment-planning-and-biomedical-engineering-service",
        isLink: true,
      },
      {
        titleKey: "services.health.section4.title",
        title: "Healthcare Interior Design",
        titleFa: "معماری داخلی در فضاهای درمانی و ایجاد فضای شفابخش",
        contentKey: "services.health.section4.content",
        content:
          "Creating healing environments through specialized interior architecture that understands the unique needs and constraints of healthcare spaces.",
        slug: "healthcare-interior-design",
        isLink: true,
      },
      {
        titleKey: "services.health.section5.title",
        title: "Healthcare Project Management",
        titleFa: "مدیریت پروژه‌های درمانی",
        contentKey: "services.health.section5.content",
        content:
          "Professional project management services ensuring healthcare projects are delivered on time, within budget, and to the highest quality standards.",
        slug: "healthcare-project-management",
        isLink: true,
      },
      {
        titleKey: "services.health.section6.title",
        title: "MEPF Specialized Engineering Design for Healthcare Facilities",
        titleFa:
          "ارائه خدمات طراحی تخصصی شامل مکانیکال، الکتریکال، آتش‌نشانی و ... در حوزه درمان",
        contentKey: "services.health.section6.content",
        content:
          "Specialized MEPF (Mechanical, Electrical, Plumbing, Fire Protection) engineering design tailored for the unique requirements of healthcare facilities.",
        slug: "mepf-specialized-engineering-design-for-healthcare-facilities",
        isLink: true,
      },
      {
        titleKey: "services.health.section7.title",
        title: "Healthcare Facility Construction and Renovation",
        titleFa: "ساخت، توسعه و بازسازی تخصصی مراکز درمانی",
        contentKey: "services.health.section7.content",
        content:
          "Specialized construction, expansion, and renovation services for healthcare facilities with strict adherence to medical standards.",
        slug: "healthcare-facility-construction-and-renovation",
        isLink: true,
      },
    ],
    stats: [
      {
        label: "Years Experience",
        labelKey: "services.health.stats.yearsExperience",
        value: "15+",
      },
      {
        label: "Healthcare Projects",
        labelKey: "services.health.stats.healthcareProjects",
        value: "30+",
      },
      {
        label: "Team Specialists",
        labelKey: "services.health.stats.teamSpecialists",
        value: "10+",
      },
    ],
  },

  "healthcare-architecture-and-facility-planning": {
    slug: "healthcare-architecture-and-facility-planning",
    parentSlug: "healthcare",
    titleKey: "services.health.sub.architecture.title",
    title: "Healthcare Architecture and Facility Planning",
    heroImage: serviceImages.healthcare,
    descriptionKey: "services.health.sub.architecture.description",
    description:
      "Kavak covers a full range of specialized services in planning and architecture of healthcare and medical spaces. Healthcare space design is based on the project master plan. The plans for each department are meticulously prepared based on the needs previously defined in the project brief and key planning units in the service plan. At this stage, there is usually more than one solution to achieve the desired outcome, each of which may place different emphasis on the mode of operation and staffing deployment. These approaches are reviewed and finalized in coordination with the client's representatives. By providing templates, executive examples, and past experiences from actual built structures, this team assists the client in the decision-making process for planning each department. All design stages from the beginning of the project are carried out using CAD/BIM systems, combining 2D drawings and 3D models.",

    // متن بلند اضافی
    introExtendedKey: "services.health.sub.architecture.introExtended",
    introExtended:
      "Healthcare facility planning is complex and requires precise knowledge of the proper relationships between different components. Simultaneously considering various flows — including patient flow, staff movement, consumable supplies, medical equipment — while accounting for diagnostic and treatment procedures and related protocols plays a vital role in the optimal and integrated design of healthcare facilities. For example, certain spaces or functional planning units must be placed adjacent to each other to form proper spatial relationships, ultimately creating an efficient, safe, and easy-to-operate facility. The absence of such proper relationships can lead to increased operational costs, unsafe pathways, and reduced flexibility in accommodating future growth and changes. Planning a complex healthcare facility is based on applying knowledge and experience of 'proper functional relationships between components' that are standard and common in healthcare systems of developed countries and in Iran; and simultaneously, existing constraints and compliance with regulations, codes, and various guidelines including infection control etc. are meticulously implemented in the design.\n\nWith expertise in determining the most optimal functional relationships to achieve the best outcome for each facility, and with access to a comprehensive collection of samples, standards, templates, and specialized tools, this team carries out the complete and integrated planning and design process for healthcare and medical facilities.",

    // لیست خدمات
    servicesList: [
      {
        titleKey: "services.health.sub.architecture.serviceItem1",
        title: "Concept Design",
      },
      {
        titleKey: "services.health.sub.architecture.serviceItem2",
        title: "Scheme Design",
      },
      {
        titleKey: "services.health.sub.architecture.serviceItem3",
        title: "Detailed Design",
      },
      {
        titleKey: "services.health.sub.architecture.serviceItem4",
        title: "Master Planning",
      },
      {
        titleKey: "services.health.sub.architecture.serviceItem5",
        title: "Functional Medical Planning",
      },
      {
        titleKey: "services.health.sub.architecture.serviceItem6",
        title: "Briefing, Schedules of Accommodation, Room Data Sheets",
      },
      {
        titleKey: "services.health.sub.architecture.serviceItem7",
        title: "Detailed Design, Room Layout Sheets",
      },
      {
        titleKey: "services.health.sub.architecture.serviceItem8",
        title: "Construction Documentation",
      },
      {
        titleKey: "services.health.sub.architecture.serviceItem9",
        title: "Project Design Specifications",
      },
    ],

    // عکس جداکننده
    dividerImage: null, // بعداً src واقعی

    // ۵ دپارتمان لینک‌دار
    departments: [
      {
        titleKey: "services.health.sub.architecture.dept.imaging.title",
        title: "Imaging Department Design",
        slug: "imaging-department",
        image: null,
      },
      {
        titleKey: "services.health.sub.architecture.dept.radiotherapy.title",
        title: "Radiotherapy Department Design",
        slug: "radiotherapy-department",
        image: null,
      },
      {
        titleKey: "services.health.sub.architecture.dept.ivf.title",
        title: "IVF Department Design",
        slug: "ivf-department",
        image: null,
      },
      {
        titleKey: "services.health.sub.architecture.dept.endoscopy.title",
        title: "Endoscopy Department Design",
        slug: "endoscopy-department",
        image: null,
      },
      {
        titleKey: "services.health.sub.architecture.dept.ldr.title",
        title: "LDR Department Design",
        slug: "ldr-department",
        image: null,
      },
    ],

    // سکشن‌های قبلی حذف — ساختار عوض شد
    sections: [],

    stats: [
      {
        label: "Departments Designed",
        labelKey: "services.health.sub.architecture.stats.departmentsDesigned",
        value: "50+",
      },
      {
        label: "Hospital Projects",
        labelKey: "services.health.sub.architecture.stats.hospitalProjects",
        value: "15+",
      },
      {
        label: "BIM Models",
        labelKey: "services.health.sub.architecture.stats.bimModels",
        value: "30+",
      },
    ],
  },

  // ===== ۵ دپارتمان زیرسرویس ۱ =====

  "imaging-department": {
    slug: "imaging-department",
    parentSlug: "healthcare-architecture-and-facility-planning",
    grandParentSlug: "healthcare",
    titleKey: "services.health.sub.architecture.dept.imaging.title",
    title: "Imaging Department Design",
    heroImage: serviceImages.healthcare,
    descriptionKey: "services.health.sub.architecture.dept.imaging.description",
    description:
      "Specialized design of imaging departments including CT, MRI, X-Ray, Ultrasound, and Mammography rooms with precise attention to radiation protection, workflow optimization, and patient experience.",
    sections: [
      {
        titleKey:
          "services.health.sub.architecture.dept.imaging.section1.title",
        title: "Design Approach",
        contentKey:
          "services.health.sub.architecture.dept.imaging.section1.content",
        content: "Content will be added soon.",
      },
    ],
    projectGallery: [
      {
        image: null,
        projectSlug: null,
        captionKey:
          "services.health.sub.architecture.dept.imaging.gallery1.caption",
        caption: "Project Name 1",
      },
      {
        image: null,
        projectSlug: null,
        captionKey:
          "services.health.sub.architecture.dept.imaging.gallery2.caption",
        caption: "Project Name 2",
      },
    ],
    stats: [],
  },

  "radiotherapy-department": {
    slug: "radiotherapy-department",
    parentSlug: "healthcare-architecture-and-facility-planning",
    grandParentSlug: "healthcare",
    titleKey: "services.health.sub.architecture.dept.radiotherapy.title",
    title: "Radiotherapy Department Design",
    heroImage: serviceImages.healthcare,
    descriptionKey:
      "services.health.sub.architecture.dept.radiotherapy.description",
    description:
      "Design and planning of radiotherapy departments with expertise in bunker design, linear accelerator room layout, treatment planning areas, and patient flow optimization.",
    sections: [
      {
        titleKey:
          "services.health.sub.architecture.dept.radiotherapy.section1.title",
        title: "Design Approach",
        contentKey:
          "services.health.sub.architecture.dept.radiotherapy.section1.content",
        content: "Content will be added soon.",
      },
    ],
    projectGallery: [
      {
        image: null,
        projectSlug: null,
        captionKey:
          "services.health.sub.architecture.dept.radiotherapy.gallery1.caption",
        caption: "Project Name 1",
      },
    ],
    stats: [],
  },

  "ivf-department": {
    slug: "ivf-department",
    parentSlug: "healthcare-architecture-and-facility-planning",
    grandParentSlug: "healthcare",
    titleKey: "services.health.sub.architecture.dept.ivf.title",
    title: "IVF Department Design",
    heroImage: serviceImages.healthcare,
    descriptionKey: "services.health.sub.architecture.dept.ivf.description",
    description:
      "Specialized design of IVF departments with focus on laboratory environments, clean room standards, embryology lab design, and patient comfort areas.",
    sections: [
      {
        titleKey: "services.health.sub.architecture.dept.ivf.section1.title",
        title: "Design Approach",
        contentKey:
          "services.health.sub.architecture.dept.ivf.section1.content",
        content: "Content will be added soon.",
      },
    ],
    projectGallery: [
      {
        image: null,
        projectSlug: null,
        captionKey:
          "services.health.sub.architecture.dept.ivf.gallery1.caption",
        caption: "Project Name 1",
      },
    ],
    stats: [],
  },

  "endoscopy-department": {
    slug: "endoscopy-department",
    parentSlug: "healthcare-architecture-and-facility-planning",
    grandParentSlug: "healthcare",
    titleKey: "services.health.sub.architecture.dept.endoscopy.title",
    title: "Endoscopy Department Design",
    heroImage: serviceImages.healthcare,
    descriptionKey:
      "services.health.sub.architecture.dept.endoscopy.description",
    description:
      "Planning and design of endoscopy departments including procedure rooms, recovery areas, decontamination zones, and patient flow management systems.",
    sections: [
      {
        titleKey:
          "services.health.sub.architecture.dept.endoscopy.section1.title",
        title: "Design Approach",
        contentKey:
          "services.health.sub.architecture.dept.endoscopy.section1.content",
        content: "Content will be added soon.",
      },
    ],
    projectGallery: [
      {
        image: null,
        projectSlug: null,
        captionKey:
          "services.health.sub.architecture.dept.endoscopy.gallery1.caption",
        caption: "Project Name 1",
      },
    ],
    stats: [],
  },

  "ldr-department": {
    slug: "ldr-department",
    parentSlug: "healthcare-architecture-and-facility-planning",
    grandParentSlug: "healthcare",
    titleKey: "services.health.sub.architecture.dept.ldr.title",
    title: "LDR Department Design",
    heroImage: serviceImages.healthcare,
    descriptionKey: "services.health.sub.architecture.dept.ldr.description",
    description:
      "Design of Labor, Delivery, and Recovery (LDR) departments with emphasis on family-centered care, natural birthing environments, emergency preparedness, and neonatal care adjacencies.",
    sections: [
      {
        titleKey: "services.health.sub.architecture.dept.ldr.section1.title",
        title: "Design Approach",
        contentKey:
          "services.health.sub.architecture.dept.ldr.section1.content",
        content: "Content will be added soon.",
      },
    ],
    projectGallery: [
      {
        image: null,
        projectSlug: null,
        captionKey:
          "services.health.sub.architecture.dept.ldr.gallery1.caption",
        caption: "Project Name 1",
      },
    ],
    stats: [],
  },

  // ============================================================
  // زیرسرویس ۲ — Health Service Planning
  // ============================================================
  "healthcare-service-planning": {
    slug: "healthcare-service-planning",
    parentSlug: "healthcare",
    titleKey: "services.health.sub.servicePlanning.title",
    title: "Healthcare Service Planning",
    heroImage: serviceImages.healthcare,
    descriptionKey: "services.health.sub.servicePlanning.description",
    description:
      "Strategic planning and management of healthcare services, ensuring optimal resource allocation and patient care delivery across all departments.",
    sections: [
      {
        titleKey: "services.health.sub.servicePlanning.section1.title",
        title: "Our Approach",
        contentKey: "services.health.sub.servicePlanning.section1.content",
        content: "Content will be added soon.",
      },
      {
        titleKey: "services.health.sub.servicePlanning.section2.title",
        title: "Services Include",
        contentKey: "services.health.sub.servicePlanning.section2.content",
        content: "Content will be added soon.",
      },
    ],
    stats: [],
  },

  // ============================================================
  // زیرسرویس ۳ — Medical Equipment Planning
  // ============================================================
  "medical-equipment-planning-and-biomedical-engineering-service": {
    slug: "medical-equipment-planning-and-biomedical-engineering-service",
    parentSlug: "healthcare",
    titleKey: "services.health.sub.medicalEquipment.title",
    title: "Medical Equipment Planning and Biomedical Engineering Service",
    heroImage: serviceImages.healthcare,
    descriptionKey: "services.health.sub.medicalEquipment.description",
    description:
      "Expert medical equipment planning integrated with biomedical engineering services, ensuring seamless coordination between architectural design and medical technology.",
    sections: [
      {
        titleKey: "services.health.sub.medicalEquipment.section1.title",
        title: "Our Approach",
        contentKey: "services.health.sub.medicalEquipment.section1.content",
        content: "Content will be added soon.",
      },
      {
        titleKey: "services.health.sub.medicalEquipment.section2.title",
        title: "Services Include",
        contentKey: "services.health.sub.medicalEquipment.section2.content",
        content: "Content will be added soon.",
      },
    ],
    stats: [],
  },

  // ============================================================
  // زیرسرویس ۴ — Healthcare Interior Design
  // ============================================================
  "healthcare-interior-design": {
    slug: "healthcare-interior-design",
    parentSlug: "healthcare",
    titleKey: "services.health.sub.interiorDesign.title",
    title: "Healthcare Interior Design",
    heroImage: serviceImages.healthcare,
    descriptionKey: "services.health.sub.interiorDesign.description",
    description:
      "Creating healing environments through specialized interior architecture, combining knowledge of healthcare standards with anthropological insights to design spaces that promote recovery and well-being.",
    sections: [
      {
        titleKey: "services.health.sub.interiorDesign.section1.title",
        title: "Our Approach",
        contentKey: "services.health.sub.interiorDesign.section1.content",
        content: "Content will be added soon.",
      },
      {
        titleKey: "services.health.sub.interiorDesign.section2.title",
        title: "Services Include",
        contentKey: "services.health.sub.interiorDesign.section2.content",
        content: "Content will be added soon.",
      },
    ],
    stats: [],
  },

  // ============================================================
  // زیرسرویس ۵ — Healthcare Project Management
  // ============================================================
  "healthcare-project-management": {
    slug: "healthcare-project-management",
    parentSlug: "healthcare",
    titleKey: "services.health.sub.projectManagement.title",
    title: "Healthcare Project Management",
    heroImage: serviceImages.healthcare,
    descriptionKey: "services.health.sub.projectManagement.description",
    description:
      "Professional project management services specialized for healthcare facilities, ensuring projects are delivered on time, within budget, and to the highest quality standards.",
    sections: [
      {
        titleKey: "services.health.sub.projectManagement.section1.title",
        title: "Our Approach",
        contentKey: "services.health.sub.projectManagement.section1.content",
        content: "Content will be added soon.",
      },
      {
        titleKey: "services.health.sub.projectManagement.section2.title",
        title: "Services Include",
        contentKey: "services.health.sub.projectManagement.section2.content",
        content: "Content will be added soon.",
      },
    ],
    stats: [],
  },

  // ============================================================
  // زیرسرویس ۶ — MEPF Engineering
  // ============================================================
  "mepf-specialized-engineering-design-for-healthcare-facilities": {
    slug: "mepf-specialized-engineering-design-for-healthcare-facilities",
    parentSlug: "healthcare",
    titleKey: "services.health.sub.mepf.title",
    title: "MEPF Specialized Engineering Design for Healthcare Facilities",
    heroImage: serviceImages.healthcare,
    descriptionKey: "services.health.sub.mepf.description",
    description:
      "Specialized Mechanical, Electrical, Plumbing, and Fire Protection engineering design services tailored for the unique and critical requirements of healthcare facilities.",
    sections: [
      {
        titleKey: "services.health.sub.mepf.section1.title",
        title: "Our Approach",
        contentKey: "services.health.sub.mepf.section1.content",
        content: "Content will be added soon.",
      },
      {
        titleKey: "services.health.sub.mepf.section2.title",
        title: "Services Include",
        contentKey: "services.health.sub.mepf.section2.content",
        content: "Content will be added soon.",
      },
    ],
    stats: [],
  },

  // ============================================================
  // زیرسرویس ۷ — Construction and Renovation
  // ============================================================
  "healthcare-facility-construction-and-renovation": {
    slug: "healthcare-facility-construction-and-renovation",
    parentSlug: "healthcare",
    titleKey: "services.health.sub.construction.title",
    title: "Healthcare Facility Construction and Renovation",
    heroImage: serviceImages.healthcare,
    descriptionKey: "services.health.sub.construction.description",
    description:
      "Specialized construction, expansion, and renovation of healthcare facilities with strict adherence to medical standards, infection control protocols, and regulatory requirements.",
    sections: [
      {
        titleKey: "services.health.sub.construction.section1.title",
        title: "Our Approach",
        contentKey: "services.health.sub.construction.section1.content",
        content: "Content will be added soon.",
      },
      {
        titleKey: "services.health.sub.construction.section2.title",
        title: "Services Include",
        contentKey: "services.health.sub.construction.section2.content",
        content: "Content will be added soon.",
      },
    ],
    stats: [],
  },
};

// Client-approved service content and link targets (slides 22–58).
serviceCard.find(s => s.slug === 'design').descriptionKey = 'services.design.card';
serviceCard.find(s => s.slug === 'construction').descriptionKey = 'services.construction.card';
serviceCard.find(s => s.slug === 'drywall').descriptionKey = 'services.drywall.card';
serviceDetailData.healthcare.teamMembers = [
  { name: 'Eng. Samira Ramezani', nameKey: 'services.health.team.member1.name', roleKey: 'services.health.team.member1.role', image: samira, resumeLink: '/team/samira-ramezani' },
  { name: 'Dr. Alireza Toolou', nameKey: 'services.health.team.member2.name', roleKey: 'services.health.team.member2.role', image: null, resumeLink: '/team/alireza-toolou' },
];
serviceDetailData['healthcare-architecture-and-facility-planning'].introExtended = null;
serviceDetailData['medical-equipment-planning-and-biomedical-engineering-service'].sections = serviceDetailData['medical-equipment-planning-and-biomedical-engineering-service'].sections.slice(1);
serviceDetailData['healthcare-interior-design'].sections = serviceDetailData['healthcare-interior-design'].sections.slice(1);

legacyProjectsData.push(...additionalServiceProjects);

// Legacy metadata is retained above; galleries and membership come from the new source folders.
export const allProjectsData = referenceProjects.map((project, index) => {
  const old = legacyProjectsData.find(p => p.projectName === project.projectName && p.link === `/${project.category}`)
    || legacyProjectsData.find(p => p.projectName === project.projectName);
  return { ...old, id: index + 1, projectName: project.projectName, link: `/${project.category}`,
    title: project.projectName === "twenty-fifth-residential" ? "Twenty-fifth Residential" : old?.title || project.projectName.replace(/-/g, " "), titleFa: /[\u0600-\u06ff]/.test(project.label) ? project.label : old?.titleFa,
    src: project.files.map(src => ({src})), videoSrc: undefined, secondVideo: undefined };
});
